import { render, staticRenderFns } from "./ItemWriteCollectionComponent.vue?vue&type=template&id=11e8a083&scoped=true&"
import script from "./ItemWriteCollectionComponent.vue?vue&type=script&lang=js&"
export * from "./ItemWriteCollectionComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11e8a083",
  null
  
)

export default component.exports